// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"0387e61c","217":"0387e61c","794":"cf0c4039"}[chunkId] + ".chunk.css";
};